import { Component, Input, OnInit } from '@angular/core';
import { CycleBpModel } from 'src/app/shared/models/societe-linked/bp/cycle-bp.model';

@Component({
  selector: 'app-cycles-bp',
  templateUrl: './cycles-bp.component.html',
  styleUrls: ['./cycles-bp.component.scss']
})
export class CyclesBpComponent implements OnInit  {

  @Input() title: string;
  @Input() cycles: CycleBpModel[];

  constructor() { }

  ngOnInit(): void {
  }

  getSortedArrayByDate(): CycleBpModel[] {
    const arraySorted = this.cycles.sort((a: CycleBpModel, b: CycleBpModel) => {
      return +new Date(b.dAction) - +new Date(a.dAction);
    });
    return arraySorted;
  }
}
